import { passengerTypeAction } from "../../../Actions/Index";
import { getCmsGroupBookingAction } from "../../../Actions/LogicActions/CmsGroupBooking/GetCmsGroupBookingAction";
import { checkRequiredValidationAction } from "../../../Actions/LogicActions/ServiceRequest/CheckRequiredValidationAction";
import { getServiceRequestCategories } from "../../../Actions/LogicActions/ServiceRequest/GetServiceRequestCategories";
import { onChangeServiceRequestControlsAction } from "../../../Actions/LogicActions/ServiceRequest/OnChangeServiceRequestControlsAction";
import { saveServiceRequestAction } from "../../../Actions/LogicActions/ServiceRequest/SaveServiceRequestAction";
import { setAdditionalFieldsAction } from "../../../Actions/LogicActions/ServiceRequest/SetAdditionalFieldsAction";
import { setGroupBookingFieldsAction } from "../../../Actions/LogicActions/ServiceRequest/SetGroupBookingFieldsAction";
import { _eventBus } from "../../../core/events/EventBus";
import { StepDefinition } from "../../../core/flows/StepDefinition";
import { StepFlow } from "../../../core/flows/StepFlow";
import { srReqClaimTree } from "../../../Orchestrator/ConstantTree/ServiceRequestClaim/ServiceRequestClaim";
import { getRecoilStateValue, updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IOnChangeServiceRequestControlsActionParams, ISaveServiceRequestActionParams } from "../../../Orchestrator/Types/Interface/ActionParams/ServiceRequestActionParams";

export class GroupBookingInitStep extends StepFlow {
    get stepName() { return "GroupBookingInit_Step"; }

    async onEventSetup(): Promise<void> {
        this.registerEventSubscription(
            _eventBus.on<string, void>({
                eventName: srReqClaimTree.Category.Get,
                handler: async ({ data }) => {
                    if (data) {
                        getServiceRequestCategories.setParams(data);
                        await getServiceRequestCategories.execute();
                    }
                }
            })
        )
        this.registerEventSubscription(
            _eventBus.on<void, void>({
                eventName: srReqClaimTree.RequestClaim.setFields,
                handler: async () => {
                    const selectedCategoryAndSubCategory: any = getRecoilStateValue("selectedCategoryAndSubCategoryAtom");
                    if (selectedCategoryAndSubCategory?.category === "GROUP_BOOKING_FORM" && selectedCategoryAndSubCategory?.subCategory === "GROUP_BOOKING") {
                        setGroupBookingFieldsAction.setParams();
                        await setGroupBookingFieldsAction.execute();
                    }
                }
            })
        )
        this.registerEventSubscription(
            _eventBus.on<IOnChangeServiceRequestControlsActionParams, void>({
                eventName: srReqClaimTree.RequestClaim.handleChange,
                handler: async ({ data }) => {
                    if (data) {
                        onChangeServiceRequestControlsAction.setParams(data)
                        await onChangeServiceRequestControlsAction.execute()
                    }
                }
            })
        )
        this.registerEventSubscription(
            _eventBus.on<ISaveServiceRequestActionParams, void>({
                eventName: srReqClaimTree.RequestClaim.RequiredValidation,
                handler: async ({ data }) => {
                    if (data) {
                        checkRequiredValidationAction.setParams(data);
                        await checkRequiredValidationAction.execute();
                    }
                }
            })
        )
        this.registerEventSubscription(
            _eventBus.on<ISaveServiceRequestActionParams, void>({
                eventName: srReqClaimTree.RequestClaim.Save,
                handler: async ({ data }) => {
                    if (data) {
                        saveServiceRequestAction.setParams(data)
                        await saveServiceRequestAction.execute()
                    }
                }
            })
        )
    }

    async onExecute(): Promise<void> {
        console.log("Group Booking Step Initialize.....");
        updateRecoilState("saveServiceRequestResponseAtom", null);
        updateRecoilState("selectedCategoryAndSubCategoryAtom", {
            category: "GROUP_BOOKING_FORM",
            subCategory: "GROUP_BOOKING",
        });
        _eventBus.emit({
            eventName: srReqClaimTree.Category.Get,
            data: "NO_BOOKING",
        });
        await getCmsGroupBookingAction.execute();
        await passengerTypeAction.execute();
        updateRecoilState("passengerTypesStateAtom", passengerTypeAction.result);
    }

}

export const GroupBookingInitStepDeclaration = new StepDefinition({
    stepName: "GroupBookingInit_Step",
    stepClass: GroupBookingInitStep
});